
export const LookUpStore = {
    namespaced: true,

    state: () => ({}),

    mutations: {},

    actions: {},

    getters: {

        //Job Status
        JobStatusMap: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("StatusMap");
        },
        JobStatusList: (state, getters) => {
            return getters.JobStatusMap;
        },
        JobStatus: (state, getters) => (Id) => {
            return getters.JobStatusList?.find(x => x.Id == Id)
        },

        AssignmentMap: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("AssignmentMap");
        },

        //Job Sub-Status
        JobSubStatusList(state, getters) {
            return getters.JobStatusMap?.flatMap(status => status.JobSubStatuses);
        },
        JobSubStatusListByParent: (state, getters) => (ParentId) => {
            return getters.JobSubStatusList?.filter(y => y.ParentId == ParentId)
        },
        JobSubStatus: (state, getters) => (Id) => {
            return getters.JobSubStatusList?.find(x => x.Id == Id)
        },


        //Job Priority
        JobPriorityList: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("PriorityList");
        },
        JobPriority: (state, getters) => (Id) => {
            return getters.JobPriorityList?.find(x => x.Id == Id)
        },


        //Warranty Type
        WarrantyTypeList: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("WarrantyTypeList");
        },
        WarrantyType: (state, getters) => (Id) => {
            return getters.WarrantyTypeList?.find(x => x.Id == Id)
        },


        //Repair Location
        RepairLocationList: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("RepairLocationList");
        },
        RepairLocation: (state, getters) => (Id) => {
            return getters.RepairLocationList?.find(x => x.Id == Id)
        },


        //Job Category
        JobCategoryList: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("JobCategoryList");
        },
        JobCategory: (state, getters) => (Id) => {
            return getters.JobCategoryList?.find(x => x.Id == Id)
        },

        //Job Type
        JobTypeList: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("JobTypeList");
        },
        JobType: (state, getters) => (Id) => {
            return getters.JobTypeList?.find(x => x.Id == Id)
        },

        //Contract Type
        ContractTypeMap: (state, getters, rootState, rootGetters) => {
            return rootGetters["BackgroundUpdater/Value"]("ContractTypeMap");
        },
        ContractTypeList: (state, getters) => {
            return getters.ContractTypeMap;
        },
        ContractType: (state, getters) => (Id) => {
            return getters.ContractTypeMap?.find(x => x.Id == Id)
        },
    }
}